<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn color="rtsPrimary" dark v-on="on">Add Note</v-btn>
      </template>
      <v-card>
        <v-card-title fixed>
          <span class="headline">Add a note for order #{{order.id}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear
          v-if="loading"
          indeterminate
        ></v-progress-linear>
        <v-card-text style="height: 500px;">
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    :disabled="loading"
                    filled
                    v-model="note"
                    label="Note"
                    rows="4"
                    row-height="30"
                    shaped
                    required
                    :rules="[v => !!v || 'Note is required']"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions fixed>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false" :disabled="loading">Close</v-btn>
          <v-btn color="blue darken-1" text @click="addNewNote()" :disabled="loading" :loading="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { POSTNOTE } from '@/store/actions.type'
export default {
  name: 'AddNote',
  components: {
  },
  data: () => ({
    dialog: false,
    note: null,
    loading: false
  }),
  props: {
    order: null,
    type: null
  },
  mounted () {},
  methods: {
    addNewNote (data) {
      let assignerNotePayload = {
        note: this.note,
        order: this.order.id,
        type: this.type
      }
      this.loading = true
      if (this.$refs.form.validate()) {
        this.$store.dispatch(POSTNOTE, assignerNotePayload).then(noteResponse => {
          this.loading = false
          this.dialog = false
          this.$emit('noteAdded', noteResponse)
        })
      } else {
        this.loading = false
      }
    }
  }
}
</script>
